export default __webpack_public_path__ + "assets/images/9ee721a6aef4d777543f5a3e00693ec6.svg";